import React from 'react'
import { Link, makeStyles } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import DazzedParagraph12 from 'components/common/text/DazzedParagraph12'
import { getShipmentView } from './scopeOrderShipmentUtils'

const useStyles = makeStyles({
  root: {
    marginTop: 4,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'baseline',
    columnGap: 8,
    color: 'var(--text-color-11)'
  },
  status: {
    fontWeight: 500
  },
  link: {
    fontSize: 12,
    color: 'var(--primary-color)',
    textDecoration: 'underline'
  }
})

/**
 * Shipment status and tracking numbers of a scope order, shown under its payment in Billing > Payment History.
 * Only orders sent to ShipBob reach here (see the billing tracking endpoint), so manual and backfilled orders show nothing.
 */
const ScopeOrderShipment = ({ order }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const view = getShipmentView(order)
  if (!view) return null

  return (
    <div className={classes.root} id={`billing-scope-order-shipment-${order.id}`}>
      <DazzedParagraph12 className={classes.status}>
        {t(`pages.accountSettings.billing.scopeShipment.${view.statusKey}`)}
      </DazzedParagraph12>
      {view.trackings.length > 0 && (
        <>
          <DazzedParagraph12>{t('pages.accountSettings.billing.scopeShipment.tracking')}</DazzedParagraph12>
          {view.trackings.map(({ trackingNumber, trackingUrl }) =>
            trackingUrl ? (
              <Link
                key={trackingNumber}
                href={trackingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={classes.link}
              >
                {trackingNumber}
              </Link>
            ) : (
              <DazzedParagraph12 key={trackingNumber}>{trackingNumber}</DazzedParagraph12>
            )
          )}
        </>
      )}
    </div>
  )
}

export default ScopeOrderShipment
